import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { GetReportUrl, base64Encode, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import Loader from '../../../../img/loader.gif';
import { getMasterData } from '../../actions/index';
import history from '../../../../history';

const validate = (values) => {
  const errors = {};

  if (!values.userRoleTypeId) {
    errors.userRoleTypeId = 'Please select type.';
  }
 
  return errors;
};

class CustomFieldReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      userRoleTypeId: 0,      
      iframeURL: '',
      isLoading: false,
      random: 0,
      RoleTypeList: [{ id: 1, value: 'All Staff' }, { id: 2, value: 'All Client' }],
    };    
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);    
  }

  // componentWillMount() {
  //   let masterData = {
  //     'masterdata': 'USERROLETYPE',
  //   };
  //   this.props.getMasterData(masterData);
  // }

  appointmentFilterByDate = (formData) => {
    this.resetIframe();
    
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('CL_CustomLabel_RPT');    
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "RoleTypeId","Value": "` + this.state.userRoleTypeId + `"},{"Name": "ViewTeamClientsOnlyPermissionForReports","Value": "` + this.props.viewTeamClientsOnlyPermission + `"},{"Name": "LoginUserId","Value": "` + this.props.loginUserID + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  
  handleChange = (input, selectedRecord) => {      
    this.setState({ userRoleTypeId: selectedRecord.value });
    input.onChange(selectedRecord.value);
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false });
  }

  resetIframe() {
    this.setState({ random: this.state.random + 1 });
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/staff-and-client-management-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Staff And Client Management {' > '} Custom Fields Report</h2>
        :
          <h2 className="page_title">Custom Fields Report</h2>
        }
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">
          <RaisedButton
            label="Back"
            primary={true}
            onTouchTap={()=>this.onBackClick()} />
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-4 mt-35 require">
                  <Field
                    name="userRoleTypeId"
                    label="Select Type"
                    handleNewRequest={this.handleChange}
                    //options={this.props.userRoleType}
                    options={this.state.RoleTypeList}
                    component={renderAutoCompleteSingleSelect} />
                </div>                              
                <div className="col-sm-8 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        <Iframe url={this.state.iframeURL}
          // width="450px"
          height="580px"
          id="myId"
          className="manual_report"
          display="initial"
          position="relative"
          onLoad={(e) => this.onLoadReport(e)}
          key={this.state.random}
          allowFullScreen />
      </div>
    );
  }
}

CustomFieldReport = reduxForm({
  form: 'CustomFieldReportForm',
  validate,
  enableReinitialize: true,
})(CustomFieldReport);

function mapStateToProps(state) {
  // let userRoleType = [];
  // if (state.report.master_data && state.report.master_data.userRoleType) {
  //   userRoleType = state.report.master_data.userRoleType.filter((obj) => obj.typeKey != 'BOTH');
  // }
  // console.log('state.report.master_data............',state.report.master_data.allStaffs)
  
    // Start For Role Permission

    let userScreenPermission = [];
    if (state.login.userPermission) {
      let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
      userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
    }

    let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission
    let viewTeamClientsOnlyPermission = hasDefaultAccess ? false : userScreenPermission && userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0] ? userScreenPermission.filter((obj) => obj.screenKey === 'VIEW_TEAM_CLIENTS_ONLY_REPORTS')[0].permission : false;


    // End For Role Permission
  return {
    orgID: state.login.loginUserInfo.organizationID,
    //userRoleType: userRoleType,
    access_token: state.login.access_token,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
    viewTeamClientsOnlyPermission: viewTeamClientsOnlyPermission,
    loginUserID: (state.login.loginUserInfo && state.login.loginUserInfo.userID) || null,
  };
}
export default connect(mapStateToProps, { getMasterData })(CustomFieldReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/StaffAndClientManagementReports/CustomFieldReport.js